module.exports = __webpack_public_path__ + "watermelon.51679bba.png";